import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import {useTranslation} from "react-i18next";
import {color, type} from "common/tokens";
import Card from "./Card";
import CoffeeWaitingArt from "components/Illustrations/CoffeeWaitingArt";

const useStyles = makeStyles(theme => ({
  card: {
    padding: '24px 30px',
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    background: color.ACCENT,
    [theme.breakpoints.down('sm')]: {
      padding: 20,
      gap: 16,
    },
  },
  title: {
    ...type.cardHeading,
    flex: 1,
    fontSize: 20,
    lineHeight: '28px',
    color: color.ON_ACCENT,
    margin: 0,
  },
  art: {
    width: 150,
    height: 150,
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      width: 96,
      height: 96,
    },
  },
}));

const WaitingForMenteesCard = ({menteeCount}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  return (
    <Card variant={'panel'} className={classes.card}>
      <h2 className={classes.title}>
        {t('waitingOnMenteesFirstCall', {count: menteeCount})}
      </h2>
      <CoffeeWaitingArt className={classes.art}/>
    </Card>
  );
};

export default WaitingForMenteesCard;
